import React from 'react';
import '../CSS/Profile/AmiraBevillProfile.css';

const AmiraBevillProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/amira-bevill-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Amira Bevill"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Amira Bevill</h1>
        <div className="profile-title-container">
          <p className="profile-title">Vice President of Search and Administration</p>
          <a href="https://www.linkedin.com/in/awbevill/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            Amira Bevill joined Myers McRae as Executive Search Coordinator in 2021, was appointed as Associate Vice President of Proposal and Contract Administration in 2022, and advanced to Vice President of Search and Administration in 2023. Amira has strong technological knowledge and skills, attention to detail, and a client-focused mindset.
          </p>
          <p>
            Prior to re-joining Myers McRae, Mrs. Bevill served as a quoting specialist for BeyondTrust, a global leader in cyber security, where she worked closely with sales representatives and deals desk analysts to provide accurate and value driven quotes to customers. Previously, Amira was a staff reporter for the Houston Home Journal in Perry, Georgia, covering news and events in the community and local government.
          </p>
          <p>
            Mrs. Bevill earned a Bachelor of Arts degree in Theatre in 2017 from Armstrong State University in Savannah, Georgia. As a student, Amira was a member of the national theatre honor society Alpha Psi Omega and participated in many performances. In addition, she worked on several film productions in Savannah, including Birth of a Nation, Vanished: Left Behind - Next Generation, and Rectify.
          </p>
          <p>
            After graduating, Amira chose an entrepreneurial career path with her husband. Together they own and operate Higher Forge Productions, a video production company that films weddings and develops commercial materials for corporate and non-profit organizations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AmiraBevillProfile;

